export default "__VITE_ASSET__e09b6fcc__"